<template>
    <div class="help">
        <div class="help-head">
          使用说明
        </div>
        <ul class="help-ul">
          <li>
            <label class="help-label">使用乘车</label><br />
            将手机屏幕正面朝向闸机扫码区域，与扫描口保持一个拳头的距离；<br />
            扫描成功伴随提示音，闸机将自动开闸放行；<br />
            出站时请再次打开页面，执行以上操作。<br />
          </li>
          <li>
            <label class="help-label">注意事项</label><br />
            （1）在您使用乘车码前，请确保手机正常运行、电量充足且网络畅通；<br />
            （2）使用乘车码乘坐地铁，须遵循“一人一码”原则，即一个App账号仅限一人使用仅乘车；须遵循“一进一出”原则，即一次行程，须使用同一账号同一码，刷进站一次刷出站一次；<br />
            （3）当您进出站前，可提前打开乘车码页面，以免耽误您的过闸时间。<br />
          </li>
        </ul>
        <div class="back" @click="back()">返回</div>
    </div>
</template>

<script>
export default {
  name: 'help',
  methods: {
    back () {
      window.history.go(-1)
    }
  }
}
</script>

<style scoped>
  .help-head{
    font-size: 2rem;
    font-weight: bold;
    padding: 20px 15px;
    border-bottom: 0.08rem solid #E5E5E5;
    text-align: left;
  }
  .help-label{
    font-weight: bold;
  }
  .help-ul{
    font-size: 1.4rem;
    margin-top: 14px;
    margin-bottom: 69px;
    line-height: 26px;
    display: block;
    text-align: left;
    padding: 0 2rem 0.5rem 2rem;
  }
  .help-ul li{
    list-style: inside;
  }
  .back{
    font-size: 1.7rem;
    width: 90%;
    height: 44px;
    text-align: center;
    background-color: #BA3541;
    color: #FFFFFF;
    line-height: 44px;
    border-radius: 5px;
    position: fixed;
    bottom: 15px;
    left: 50%;
    margin-left: -45%;
  }
</style>
